    <template>

<v-snackbar :value="show" :color="color? color: 'success'"   max-width="100" timeout="-1" absolute top multi-line outlined>


        <div id="flex" class="d-flex flex-column justify-center">

        <p class="text-center">
        {{message}}
        </p>
        <div class="text-center">

        <v-btn @click="closeSnackbar" max-width="10px" :color="color? color: 'success'">
            Ok
        </v-btn>


         <v-btn v-if="extra" @click="goToCollection(id)" class="ml-5" :color="color? color: 'success'">
            View
        </v-btn>

        </div>
        </div>
      </v-snackbar>

    </template>

<script>
    import {mapState} from 'vuex'

export default  {
    name: 'SnackbarMessage',
    methods: {
        closeSnackbar(){
            this.$emit('closeSnackbar')

        },
        goToCollection(id){
            this.closeSnackbar();
             this.$router.push({name: 'Collections', params: {collection_id: id}})
        }
    },
   props: ['show', 'message', 'color', 'extra', 'id'],



}
</script>
